var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigmaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13980_52593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 18.2336C18.0002 17.2258 18.4005 16.2592 19.1132 15.5466C19.8258 14.8339 20.7923 14.4336 21.8002 14.4336C22.808 14.4336 23.7745 14.8339 24.4872 15.5466C25.1998 16.2592 25.6002 17.2258 25.6002 18.2336C25.6002 19.2414 25.1998 20.208 24.4872 20.9206C23.7745 21.6332 22.808 22.0336 21.8002 22.0336C20.7923 22.0336 19.8258 21.6332 19.1132 20.9206C18.4005 20.208 18.0002 19.2414 18.0002 18.2336Z",
    fill: "#1ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4 25.8332C10.4 24.8254 10.8004 23.8588 11.513 23.1462C12.2257 22.4336 13.1922 22.0332 14.2 22.0332H18V25.8332C18 26.841 17.5997 27.8076 16.8871 28.5202C16.1744 29.2328 15.2079 29.6332 14.2 29.6332C13.1922 29.6332 12.2257 29.2328 11.513 28.5202C10.8004 27.8076 10.4 26.841 10.4 25.8332V25.8332Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 6.83398V14.434H21.8002C22.808 14.434 23.7745 14.0336 24.4872 13.321C25.1998 12.6084 25.6002 11.6418 25.6002 10.634C25.6002 9.62616 25.1998 8.65962 24.4872 7.94698C23.7745 7.23434 22.808 6.83398 21.8002 6.83398H18.0002Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4 10.634C10.4 11.6418 10.8003 12.6084 11.513 13.321C12.2256 14.0336 13.1922 14.434 14.2 14.434H18V6.83398H14.2C13.1922 6.83398 12.2256 7.23434 11.513 7.94698C10.8003 8.65962 10.4 9.62616 10.4 10.634V10.634Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4 18.2336C10.4 19.2414 10.8004 20.208 11.513 20.9206C12.2257 21.6332 13.1922 22.0336 14.2 22.0336H18V14.4336H14.2C13.1922 14.4336 12.2257 14.8339 11.513 15.5466C10.8004 16.2592 10.4 17.2258 10.4 18.2336V18.2336Z",
    fill: "#A259FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13980_52593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2,
    height: 22.8,
    fill: "white",
    transform: "translate(10.4 6.83398)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLogo);
export default __webpack_public_path__ + "static/media/figma-logo.a2115d9b178a66f5b197a9146679370c.svg";
export { ForwardRef as ReactComponent };